import { render, staticRenderFns } from "./LoanDetailPage.vue?vue&type=template&id=4819392a&scoped=true&"
import script from "./LoanDetailPage.vue?vue&type=script&lang=js&"
export * from "./LoanDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./LoanDetailPage.vue?vue&type=style&index=0&id=4819392a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4819392a",
  null
  
)

export default component.exports